import { Button, HTMLInputProps, Intent } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import React from 'react'
import Client from '../../client'
import { showToast } from '../../Toast'

interface Props {
  inputProps?: HTMLInputProps
  value?: string
  supplierId?: number
  placeholder?: string
  onChange: (string) => void
}

const BarcodeInput: React.FC<Props & HTMLInputProps> = ({
  inputProps = {},
  value,
  supplierId,
  placeholder,
  onChange,
  ...props
}) => {
  const [loading, setLoading] = React.useState(null)

  const newSku = async () => {
    setLoading(true)
    try {
      const res = await Client.newSku(supplierId)
      onChange(res.data.sku)
    } catch (error) {
      showToast('Could not generate SKU, please try again', Intent.WARNING, false)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="bp3-input-group" {...props}>
      <input
        placeholder={placeholder || 'Barcode'}
        value={value || ''}
        onChange={e => onChange(e.target.value.replace(/[^a-zA-z\d-]/, '').replace('^', ''))}
        className="bp3-input"
        {...inputProps}
      />
      <Button
        loading={loading}
        disabled={!!value}
        onClick={newSku}
        minimal
        intent={Intent.WARNING}
        icon={IconNames.BARCODE}
        style={{ marginTop: 5 }}
      />
    </div>
  )
}

export default React.memo(BarcodeInput)
